import CompareControl from './control';
import CompareCounter from './counter';

const pluginName = 'compare';

export default {
    init() {
        let compareControl = new CompareControl();
        let $controls = $('[data-compare-add], [data-compare-remove], [data-compare-remove]');
        let $counters = $('[data-compare-count]');

        $.fn[`${pluginName}-control`] = function () {
            compareControl.init();
            return compareControl;
        };

        $.fn[`${pluginName}-counter`] = function () {
            return this.each((i, el) => {
                let compareCounter = new CompareCounter(el);
                compareCounter.init();
            });
        };

        $controls[`${pluginName}-control`]();
        $counters[`${pluginName}-counter`]();

        $(document).on('enhance:ajaxload compare:storage:change', () => {
            $('[data-compare-count]')[`${pluginName}-counter`]();
        });
    }
};
